'use strict';

module.exports = function validate (obj, checker, cname = 'shapeValidator') {
  let rootObj = {ROOT: obj};
  let checkResult = checker(rootObj, 'ROOT', cname, '$', '');
  if (checkResult) {
    throw checkResult;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-shapes/validate.js